module.exports = __webpack_public_path__ + "img/image24.649e441c.jpg";